document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".header");
  const articleMedia = document.querySelector(".js-article-media");
  const img = articleMedia?.querySelector("img");

  if (!header || !articleMedia || !img) return;

  if (window.innerWidth < 992) return;

  const DARK_THRESHOLD = 115;
  const SAMPLE_SIZE = 64;

  function getAverageLuma(imageEl) {
    return new Promise((resolve, reject) => {
      const run = () => {
        try {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d", { willReadFrequently: true });

          const w = Math.max(1, Math.min(SAMPLE_SIZE, imageEl.naturalWidth || SAMPLE_SIZE));
          const h = Math.max(1, Math.min(SAMPLE_SIZE, imageEl.naturalHeight || SAMPLE_SIZE));

          canvas.width = w;
          canvas.height = h;

          ctx.drawImage(imageEl, 0, 0, w, h);

          const { data } = ctx.getImageData(0, 0, w, h);

          let sum = 0;
          const pixels = w * h;

          for (let i = 0; i < data.length; i += 4) {
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];
            sum += 0.2126 * r + 0.7152 * g + 0.0722 * b;
          }

          resolve(sum / pixels);
        } catch (e) {
          reject(e);
        }
      };

      if (imageEl.complete && imageEl.naturalWidth) run();
      else imageEl.addEventListener("load", run, { once: true });
    });
  }

  function cloneHeader() {
    const headerClone = header.cloneNode(true);
    headerClone.classList.add("header--right-clone");

    Object.assign(headerClone.style, {
      position: "absolute",
      top: header.offsetTop + "px",
      overflow: "hidden",
      zIndex: "20",
    });

    document.body.appendChild(headerClone);
  }

  getAverageLuma(img)
    .then((avgLuma) => {
      if (avgLuma < DARK_THRESHOLD) {
        cloneHeader();
      }
    })
    .catch(() => {
    });
})

document.addEventListener("DOMContentLoaded", function () {
  const topEl = document.querySelector(".js-top");
  if (!topEl) return;

  topEl.addEventListener("mouseenter", () => {
    document.body.classList.add("with-hover-header");
  });

  topEl.addEventListener("mouseleave", () => {
    document.body.classList.remove("with-hover-header");
  });
});